import axios from "axios";
import { getUserDetails } from "./utils/shared-data.service";

export const apiPaths = {
  questionbyid: "questionbyid",
  subjects: "admin/subjects",
  tags: "admin/tags",
  topics: "admin/topics",
  subtopics: "admin/subtopics",
  saveTopic: "admin/saveTopic",
  saveTag: "admin/saveTag",
  saveSubtopic: "admin/saveSubtopic",
  dashboardGraph: "dashboardgraph",
  qbStats: "qbStats",
  getQuestionFeedbackById: "getQuestionFeedbackById",
  // serverUrl:
  uploadQuestions: "uploadQuestions",
  questionslist: "questionslist",
  questionslistPaginated: "questionslist/paginated",
  downloadBySubject: "admin/downloadQuestionsBySubject",
  searchQB: "searchQB",
  getQuestionHistory: "getQuestionHistory",
  questionslistByStatus: "questionslistbystatus",
  question: "question",
  courses: "admin/courses",
  examsList: "examsInfo",
  questionsListByExam: "getQuestionsByExamId",
  getFeedbackForQuestions: "getFeedbackForQuestions",
  questionBankQuestions: "allQuestions",
  updateQuestionFeedbackStatus: "updateQuestionFeedbackStatus",
  getQuestionsForExam: "getQuestionsForExam",
  getQuestionsByExamId: "getQuestionsByExamId",
  saveExam: "saveExam",
  pushToApp: "pushToApp",
  copyExam: "copyExam",
  batches: "admin/batches",
  branches: "admin/branches",
  delete: "questions/delete",
  deleteExam: "delete",
  updateQuestionStatus: "questions/updateStatus",
  login: "usermanagement/login",
  logout: "usermanagement/logout",
  count: "/count",
  questionstatusaudit: "questionstatusaudit",
  savecomments: "savecomments",
  questionsUpdateStatus: "questions/updateStatus",
  downloadMedia: "downloadMediaFiles",
  downloadExamPaper: "downloadExamPaper",
  downloadQB: "admin/downloadLibraryQBQuestionPaper",
  downloadTest: "admin/downloadLibraryTestQuestionPaper",
  uploadMedia: "uploadMediaFiles",
  updateExamActiveStatus: "updateExamActiveStatus",
  updateExamStatus: "updateExamStatus",
  roles: "usermanagement/roles",
  acadDeleteRole: "admin/usermanagement/deleteRole/ACAD_PORTAL",
  acadRoles: "admin/usermanagement/roles/ACAD_PORTAL",
  acadSaveRole: "admin/usermanagement/saveRole/ACAD_PORTAL",
  acadDeleteUserBranchPermission: "/admin/usermanagement/deleteUserBranchPermission/ACAD_PORTAL",
  acadUserBranchPermission: "/admin/usermanagement/getUserBranchPermissions/ACAD_PORTAL",
  saveUserBranchPermission: "/admin/usermanagement/saveUserBranchPermissions",
  listUserSubjectMap: "usermanagement/listUserSubjectMap",
  deleteUserFromSubject: "usermanagement/deleteUserFromSubject",
  MapUserToSubject: "usermanagement/MapUserToSubject",
  usersList: "usermanagement/usersList",
  acadUserList: "admin/usermanagement/usersList/ACAD_PORTAL",
  deleteUser: "usermanagement/deleteUser",
  acadDeleteUser: "admin/usermanagement/deleteUser/ACAD_PORTAL",
  saveUser: "usermanagement/saveUser",
  acadSaveUser: "admin/usermanagement/saveUser/ACAD_PORTAL",
  examstakenbyuser: "/getexamstakenbyuser",
  updateuserexamstatus: "/updateUserExamStatus",
  forgotPassword: "usermanagement/forgotPassword",
  changePassword: "usermanagement/changePassword",
  getCompletedLiveClasses: "faculty/getCompletedLiveClasses",
  getLiveClasses: "faculty/getLiveClasses",
  getLiveClassesById: "faculty/getLiveClassById",
  updateLiveClassStatus: "faculty/updateLiveClassStatus",
  getZoomSignature: "zoom/getZoomSignature",
  getLibraryQB: "admin/getLibraryQB",
  getQuestionIdsByQB: "admin/getQuestionIdsByQB",
  getQuestionIdsByTest: "admin/getQuestionIdsByTest",
  getLibraryTests: "admin/getLibraryTests",
  getLibraryTestsPaginated: "admin/getLibraryTestsPaginated",
  getTenants: "admin/auth/getTenants",
  sendQuestionFeedbackMail: "sendQuestionFeedbackMail",
  getContentFeedback: "admin/getContentFeedback",
  getContentFeedbackDetails: "admin/getContentFeedbackDetails",
  deleteQuestion: "questions/delete",
  questionByText: "questionbytext",
  deleteQuestionFromQB: "admin/deleteQuestionFromQB",
  addQuestionToQB: "admin/addQuestionToQB",
  addQuestionToTest: "/admin/addQuestionToTest",
  deleteQuestionFromTest: "/admin/deleteQuestionFromTest",
  refreshTestCache: "admin/redis/refreshTestCache",
  userPermission: "admin/auth/userPermission/ACAD_PORTAL",

  // AI Explanation (InstituteApp endpoints)
  aiExplanation: "api/ai-explanation",

  // Answer Verification / Conflicts (InstituteApp endpoints)
  answerConflicts: "api/ai-answer-conflicts",
  answerConflictsVerify: "api/ai-answer-conflicts/verify",
  answerConflictsStats: "api/ai-answer-conflicts/stats",
  answerConflictsStatsBySubject: "api/ai-answer-conflicts/stats/by-subject",
  answerConflictsUpdateExplanation: "api/ai-answer-conflicts/update-explanation",
  answerConflictsAudit: "api/ai-answer-conflicts/audit",

  // Classification Verification (InstituteApp endpoints)
  classificationConflicts: "api/ai-classification-conflicts",
  classificationConflictsVerify: "api/ai-classification-conflicts/verify",
  classificationConflictsStats: "api/ai-classification-conflicts/stats",
  classificationConflictsAudit: "api/ai-classification-conflicts/audit",

  // AI Provider Config (InstituteApp endpoints)
  aiConfigProviders: "admin/ai-config/providers",
  aiConfigProviderSupported: "admin/ai-config/providers/supported",
  aiConfigProviderTest: "admin/ai-config/providers",       // /{provider}/test
  aiConfigFeatures: "admin/ai-config/features",
  aiConfigFeaturesSupported: "admin/ai-config/features/supported",
  aiConfigModels: "admin/ai-config/models",

  // Rephrased Questions (InstituteApp endpoints)
  rephrasedQuestions: "api/rephrased-questions",
  rephrasedQuestionsStats: "api/rephrased-questions/stats",
  rephrasedQuestionVariations: "api/rephrased-questions/questions",  // /{questionId}/variations
  rephrasedQuestionApprove: "api/rephrased-questions/variations",    // /{variationId}/approve
  rephrasedQuestionReject: "api/rephrased-questions/variations",     // /{variationId}/reject
  rephrasedQuestionDelete: "api/rephrased-questions/variations",     // /{variationId}

  // Question Variations - Restyle & Generate (InstituteApp endpoints)
  questionVariationRestyleGenerate: "api/question-variations/restyle/generate",   // /{questionId}
  questionVariationRestyleGet: "api/question-variations/restyle",                 // /{questionId}
  questionVariationRestyleApply: "api/question-variations/restyle",              // /{restyledId}/apply
  questionVariationRestyleUpdate: "api/question-variations/restyle",             // /{restyledId}
  questionVariationRestyleReject: "api/question-variations/restyle",             // /{restyledId}/reject
  questionVariationRestyleDelete: "api/question-variations/restyle",             // /{restyledId}
  questionVariationRestyleStats: "api/question-variations/restyle/stats",
  questionVariationRestyleList: "api/question-variations/restyle/list",
  questionVariationGenerateNew: "api/question-variations/generate",              // /generate/{questionId}
  questionVariationGenerateGet: "api/question-variations/generate",              // /{questionId}
  questionVariationGenerateInsert: "api/question-variations/generate",           // /{generatedId}/insert
  questionVariationGenerateUpdate: "api/question-variations/generate",           // /{generatedId}
  questionVariationGenerateReject: "api/question-variations/generate",           // /{generatedId}/reject
  questionVariationGenerateDelete: "api/question-variations/generate",           // /{generatedId}
  questionVariationGenerateStats: "api/question-variations/generate/stats",
  questionVariationGenerateList: "api/question-variations/generate/list",
  questionVariationChangeLog: "api/question-variations/change-log",              // /{questionId}
  questionVariationStyleTags: "api/question-variations/style-tags",

  // LLM Prompts Management (InstituteApp endpoints)
  llmPromptsAll: "admin/llm-prompts/all",
  llmPromptsCreate: "admin/llm-prompts/create",
  llmPromptsUpdate: "admin/llm-prompts/update",             // /{promptId}
  llmPromptsDelete: "admin/llm-prompts/delete",             // /{promptId}
  llmPromptsSearch: "admin/llm-prompts/search",
  llmPromptsVersions: "admin/llm-prompts/versions",         // /{promptKey}
  llmPromptsCreateVersion: "admin/llm-prompts/create-version", // /{promptKey}
  llmPromptsDeactivate: "admin/llm-prompts/deactivate",     // /{promptKey}/version/{version}
  llmPromptsValidate: "admin/llm-prompts/validate",
  llmPromptsProcessTemplate: "admin/llm-prompts/process-template",
  llmPromptsStats: "admin/llm-prompts/stats",
  llmPromptsKeys: "admin/llm-prompts/keys",
  llmPromptsDistinctUseCases: "admin/llm-prompts/distinct/use-cases",
  llmPromptsDistinctPromptTypes: "admin/llm-prompts/distinct/prompt-types",
  llmPromptsDistinctDifficulty: "admin/llm-prompts/distinct/difficulty-levels",
  llmPromptsByUseCase: "admin/llm-prompts/use-case",        // /{useCase}
  llmPromptsByType: "admin/llm-prompts/type",               // /{promptType}
  llmPromptsByDifficulty: "admin/llm-prompts/difficulty",    // /{difficultyLevel}

  // Team Performance (QuestionBankApp endpoints)
  teamPerformanceOverview: "team-performance/overview",
  teamPerformanceMemberDetail: "team-performance/member-detail",
  teamPerformanceMemberActivity: "team-performance/member-activity",

  // Team Performance (InstituteApp endpoints)
  teamPerformanceInstOverview: "api/team-performance/overview",
  teamPerformanceInstMemberDetail: "api/team-performance/member-detail",
  teamPerformanceInstMemberActivity: "api/team-performance/member-activity",

  // Test Upload Review pipeline (InstituteApp endpoints) — under /api/ to match the
  // gateway-allowed prefix used by every other Arise-QB-React → InstituteApp endpoint
  // (api/ai-explanation, api/team-performance, api/rephrased-questions, etc.).
  testUploadJobs: "api/testupload/jobs",            // POST (create), GET (list); GET /{jobId}; GET /{jobId}/questions; POST /{jobId}/bulk-classify
  testUploadQuestions: "api/testupload/questions",  // PUT /{id}; POST /{id}/review-status; POST /{id}/use-existing; DELETE /{id}
  getSubjects: "data/getSubjects",              // master data for dropdowns
  topicsBySubject: "api/ai-classification-conflicts/taxonomy/topics",     // ?subjectId= -> { topics:[{id,name}] }
  subtopicsByTopic: "api/ai-classification-conflicts/taxonomy/subtopics", // ?topicId=   -> { subtopics:[{id,name}] }
};

export const get = async (url, queryparams, headers, responseType = "json") => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_API_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });
  return res?.data;
};
export const getInstutueApp = async (url, queryparams, headers, responseType = "json") => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_BASE2_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });

  // If blob, return whole response (need headers + data)
  if (responseType === "blob") {
    return res;
  }

  return res?.data;
};
export const postInstituteAppData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.post(
      process.env.REACT_APP_BASE2_PATH + url,
      //'https://devapi.arisemedicalacademy.com/instituteApp/'+url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};
export const putInstituteAppData = async (url = "", data = {}) => {
  try {
    let response = await axios.put(
      process.env.REACT_APP_BASE2_PATH + url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available. Please try after some time"
    );
  }
};
export const patchInstituteAppData = async (url = "", data = {}) => {
  try {
    let response = await axios.patch(
      process.env.REACT_APP_BASE2_PATH + url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available. Please try after some time"
    );
  }
};
export const deleteInstituteAppData = async (url = "", data = {}) => {
  try {
    const response = await axios.delete(process.env.REACT_APP_BASE2_PATH + url, {
      data: data.body,  // Use 'body' for request payload
      params: data.params,
      headers: {
        ...data.headers,
        userEmail: getUserDetails().email  // Ensure userEmail is always included
      }
    });
    return response?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available. Please try after some time"
    );
  }
};

export const postData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.post(
      process.env.REACT_APP_API_PATH + url,
      data.data,
      {
        params: data.params,
        headers: data.headers || { userEmail: getUserDetails().email },
      }
    );
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const deleteData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.delete(process.env.REACT_APP_API_PATH + url, {
      data: data.data,
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getData = async (url = "", data = {}) => {
  try {
    // Default options are marked with *
    let response = await axios.get(process.env.REACT_APP_API_PATH + url, {
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getAdminData = async (url = "", data = {}) => {
  console.log('url: ', url);
  console.log('process.env.REACT_APP_BASE2_PATH: ', process.env.REACT_APP_BASE2_PATH);
  try {
    // Default options are marked with *
    let response = await axios.get(process.env.REACT_APP_BASE2_PATH + url, {
      params: data.params,
      headers: data.headers || { userEmail: getUserDetails().email },
    });
    return response?.data; // parses JSON response into native JavaScript objects
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};

export const getBase2 = async (
  url,
  queryparams,
  headers,
  responseType = "json"
) => {
  // '/'
  let res = await axios.get(process.env.REACT_APP_API_PATH + url, {
    params: queryparams,
    headers: headers || { userEmail: getUserDetails().email },
    responseType,
  });
  return res?.data;
};

export const patch = async (
  url,
  queryparams,
  headers,
  responseType = "json"
) => {
  try {
    let res = await axios.patch(process.env.REACT_APP_API_PATH + url, {
      params: queryparams,
      headers: headers || { userEmail: getUserDetails().email },
      responseType,
    });
    return res?.data;
  } catch (e) {
    throw (
      e?.response?.data?.msg ||
      "Server is not available .Please  try after some time"
    );
  }
};
